import React from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { moreDetail } from '../../action';
import { ShowBuynowConfirm } from '../../action';
import BuynowConfirm from './BuynowConfirm';
import Build_sum_arrow from '../../assets/images/arrow/building-summary-arrow.svg'
import { prepareTwoDMapData } from '../../action/twoDMap.action';
import TwoDMapModal from './TwoDBuildingMap/TwoDMapModal';

function SumBar() {
    const dispatch = useDispatch();
    const state = useSelector((state) => state.reducer);
    // const down_payment = state.const_var.post_data?.building?.down_payment_total !=undefined ? state.const_var.post_data?.building?.down_payment_total : 0;
    const number_format = (param) => {
        return parseFloat(param).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    }
    // let dealer_discount = state.const_var.post_data.building != undefined && state.const_var.post_data.building.discount_amount
   
   
    // let mfg_discount = state.const_var.post_data.building != undefined && state.const_var.post_data.building.down_payment_discount_total
    // console.log(state.const_var.BuildingPriceArrar ,dealer_discount , mfg_discount , "dis")

    let manufacture_discount = (state.const_var.post_data.building!=undefined)?((state.const_var.post_data.building.sub_order_total)+state.const_var.BuildingPriceArrar["custom_subTotal"]+state.const_var.BuildingPriceArrar['additional_charges']).toFixed(2):0
    
    // let manufacturerTotal = state.const_var.post_data.building!=undefined && state.const_var.post_data.building.discount_amount!=undefined && state.const_var.post_data.building.discount_amount!=0;
    let surFlag = 0;
    if(state.const_var.post_data.building!=undefined && state.const_var.post_data.building.surcharge_on_discounted_subtotal==1)
      {
        let surVal = (state.const_var.post_data.building!=undefined && state.const_var.post_data.building.surcharge_amount!=undefined)?state.const_var.post_data.building.surcharge_amount:0;
        surFlag = manufacture_discount?(parseFloat(state.const_var.post_data.building.order_total)+ parseFloat(state.const_var.BuildingPriceArrar["custom_subTotal"]+state.const_var.BuildingPriceArrar['additional_charges']) +parseFloat(surVal)).toFixed(2):(state.const_var.BuildingPriceArrar['sub_order_total']!=undefined)?state.const_var.BuildingPriceArrar['sub_order_total'].toFixed(2):0; 
      }else{
        surFlag = (state.const_var.BuildingPriceArrar['order_total']!=undefined)?((state.const_var.BuildingPriceArrar['order_total'] + state.const_var.BuildingPriceArrar["custom_subTotal"] + state.const_var.BuildingPriceArrar['additional_charges'])).toFixed(2):0;
      }
    let dealerDeposit = 0

    let dealerDepositFirst = ((state.const_var.BuildingPriceArrar && state.const_var.BuildingPriceArrar['down_payment_total']) ? state.const_var.BuildingPriceArrar['down_payment_total']+state.const_var.BuildingPriceArrar['custom_down_payment_total'] : 0).toFixed(2)
    let dealerDepositSecond = ((state.const_var.BuildingPriceArrar && state.const_var.BuildingPriceArrar['new_down_payment_total']) ? state.const_var.BuildingPriceArrar['new_down_payment_total']+state.const_var.BuildingPriceArrar['custom_down_payment_total']+ state.const_var.BuildingPriceArrar['grvy_value'] : 0).toFixed(2)

    dealerDeposit = (state.const_var.BuildingPriceArrar['down_payment_discount_total']!=undefined && state.const_var.BuildingPriceArrar['down_payment_discount_total']!=0)? dealerDepositFirst : dealerDepositSecond

    let dealerDiscount = (state.const_var.post_data.building!=undefined && state.const_var.post_data.building.down_payment_discount_total!=undefined)?(state.const_var.BuildingPriceArrar['new_down_payment_total'] +state.const_var.BuildingPriceArrar['custom_down_payment_total']+ state.const_var.BuildingPriceArrar['grvy_value']).toFixed(2):0

    return (
        <div className='sum-bar'>

            <div className='price-side'>
                <div className='due-container'>
                    <div className='due-today-note'>Due Today<div className='deposit'>&nbsp;(Deposit)</div>&nbsp;:</div>
                    <div className='due-price'>
                        {
                            dealerDiscount == dealerDeposit
                            ?
                                <span>&nbsp;${number_format(dealerDeposit)}</span>
                            :
                                <>
                                    {   dealerDiscount != undefined
                                        ?
                                        <>
                                            {
                                                dealerDiscount > 0 ? <span className='cut-value'>&nbsp;${number_format(dealerDeposit)}</span> : <span>&nbsp;${number_format(dealerDeposit)}</span>
                                            }
                                        </>
                                        :
                                        <span className='cut-value'>&nbsp;${number_format(0)}</span>
                                    }
                                    {
                                        dealerDiscount > 0 ? <span>&nbsp;${number_format(dealerDiscount)}</span> : null
                                    }
                                </>
                        }
                    </div>
                </div>
                <div className='total-container'>
                    <div className='total-amount'>
                        <span>Building Total :</span>
                        {
                            surFlag == manufacture_discount ?
                            <span className='theme-color'>&nbsp;${number_format(surFlag)}</span>
                            :
                            <>
                            {
                                manufacture_discount > 0 ? <span className='cut-value'>&nbsp;${number_format(surFlag)}</span> : <span className='theme-color'>&nbsp;${number_format(surFlag)}</span>
                            }
                            {
                                manufacture_discount > 0 ? <span className='theme-color'>&nbsp;${number_format(manufacture_discount)}</span> : null
                            }
                            </>
                        }
                    </div>
                    <div className='vertical'></div>
                    <div className='more-details'>
                        <span className='d-flex' onClick={(e)=> dispatch(moreDetail("show"))}>{'Building Summary'}<img className='ml-5' src={Build_sum_arrow} alt='right-arrow' /></span>
                    </div>
                </div>
            </div>
            <div className='btn-side'>
                {state.isShowBuynowConfirm && <BuynowConfirm />}
                {state.isShowBuynowConfirm && <TwoDMapModal/>}
                <div className='buy-now-btn' id='buy-now-btn' onClick={(e)=>{dispatch(prepareTwoDMapData());dispatch(ShowBuynowConfirm())}}>BUY NOW</div>
            </div>
        </div>
    )
}

export default SumBar;